'use strict';


export class ErrorStream {
  write(rec) {
    if (rec.err) {
      console.error(rec.err);
    }
  }
}

export const errorStream = new ErrorStream();



// WEBPACK FOOTER //
// ./src/js/config/logger/ErrorStream.js